import { googleTagManager } from './tracking';
import { BANA_PAGE_GROUP, BUSINESS_MODEL, trackBanaPageView, trackBanaThankYou } from './tracking/bana-tracking';

document.addEventListener('DOMContentLoaded', async () => {
    const currentPageIsFinalFormPage = ['form_page_success', 'form_page_rejection'].some((page) =>
        window.pageGroup?.startsWith(page),
    );

    // set page group retrieved from local storage in app.blade.php
    if (currentPageIsFinalFormPage) {
        googleTagManager.setPageGroup(window.pageGroup);
    }

    // fire pageview everywhere, except form pages, as based on the form type pageGroup is adjusted
    // which happens @created hook for each form type
    if (!window.pageGroup?.includes('form') || currentPageIsFinalFormPage) {
        googleTagManager.trackPageLoaded();
    }

    // Bana events (the form screens are tracked by the form itself)
    if (window.page === 'home') {
        trackBanaPageView(BANA_PAGE_GROUP.GENERAL_LANDING, null);
    } else if (window.isIcLandingPage) {
        trackBanaPageView(BANA_PAGE_GROUP.LANDING, BUSINESS_MODEL.IC);
    } else if (window.location.pathname.includes('thank-you')) {
        trackBanaThankYou();
    }
});
